/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getAvailableStamps} from '../api'

 export const useQueryGetAvailableStamps = createReactQueryHook('getAvailableStamps', getAvailableStamps)
